jQuery(window).load(function() {

	// Elon Gallery Slideshow Advanced Element
	var gallery_slideshow = $('.elon-component-gallery-slideshow');

	if (gallery_slideshow[0]) {

		$.each(gallery_slideshow, function(idx, val) {
			
			var component_id = $(this).parent().data('component');
			var dots = $(this).data('dots');
			var autoplay = $(this).data('auto');

			var owlCar = $(this).owlCarousel({
				loop: true,
				nav: true,
				navText: [
					'<i class="fa fa-angle-left" aria-hidden="true"></i><span class="sr-only">Previous</span>',
					'<i class="fa fa-angle-right" aria-hidden="true"></i><span class="sr-only">Next</span>'
				],
				dots: dots,
				dotsContainer: '#owlDots_' + component_id,
				autoplay: autoplay,
				items: 1
			});

			$(this).trigger('refresh.owl.carousel');

		});

	}

	// Flickr Gallery Slideshow Advanced Element
	var flickr_slideshows = $('.flickr-embed');

	if (flickr_slideshows[0]) {

		/*
		var script_tag = document.createElement('script');
		script_tag.src = 'https://embedr.flickr.com/assets/client-code.js';
		script_tag.async = 'async';
		document.body.appendChild(script_tag);
		*/

		$.each(flickr_slideshows, function(idx, val) {

			var slideshow = $(this);

			/**
			 * Starting with the $.get() method, we were experimenting with a JavaScript solution
			 * based on the most recent (as of 4/22) Flickr embed implementation. It's not perfect,
			 * so we're going to use the iframe method until we've had time to really work this
			 * one out.
			 */

			/*
			$.get(flickr_album, function(data) {

				var cover_img = $(data).find('.album-header-content').css('background-image');
				cover_img = cover_img.replace('url("', 'https:');
				cover_img = cover_img.replace('")', '');
				console.log(cover_img);
				// clear our any existing markup
				$(this).html('');

				// write new markup
				var flickr_markup = '<a data-flickr-embed="true" href="' + flickr_album + '" title="Flickr Album"><img src="' + cover_img + '" width="640" height="480" alt="Flickr Gallery"></a>';
				slideshow.html(flickr_markup);

			});
			*/

			// iFrame method: Only run this if an iframe isn't already present.
			if (!slideshow.find('iframe')[0]) {

				var flickr_album = slideshow.data('url');
				var album_classes_str = slideshow.attr('class');
				var album_classes_arr = album_classes_str.split(' ');
				var album_size, album_height;

				album_classes_arr = album_classes_arr.filter(function(s) {
					return ~s.indexOf('size');
				});

				if (album_classes_arr[0]) {
					album_size = album_classes_arr[0];
				} else {
					album_size = 'size-full'; // else, assume full size album
				}

				switch(album_size) {

					case 'size-small':
						album_height = 200;
						break;

					case 'size-medium':
						album_height = 350;
						break;

					case 'size-large':
						album_height = 450;
						break;

					default:
						album_height = 550; // default to size-full

				}

				//var album_id = flickr_album.substring(flickr_album.indexOf('/albums/') + 1).replace('albums/', '');
				var slideshow_html = '<iframe width="100%" height="' + album_height + '" frameborder="0" src="' + flickr_album + '/player/"></iframe>';

				slideshow.html(slideshow_html);

			}

		});

	}

});